module.exports = __webpack_public_path__ + "img/studio图3.2e117c97.png";